<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
#app {
  height: 100%;
  width: 100%;
  /* background: #fff; */
  position: relative;
  /* font-family: "iconfont"; */
}
/* .iconfont{
    font-family:"iconfont" !important;
    font-size:16px;font-style:normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
} */
/* @font-face {
  font-family: 'iconfont';
  src: url('//at.alicdn.com/t/font_512267_5fgtmx4cwmf.eot');
  src: url('//at.alicdn.com/t/font_512267_5fgtmx4cwmf.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_512267_5fgtmx4cwmf.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_512267_5fgtmx4cwmf.woff') format('woff'),
  url('//at.alicdn.com/t/font_512267_5fgtmx4cwmf.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_512267_5fgtmx4cwmf.svg#iconfont') format('svg');
} */
@font-face {
  font-family: "iconfont"; /* Project id 512267 */
  src: url("iconfont.woff2?t=1661842038822") format("woff2"),
    url("iconfont.woff?t=1661842038822") format("woff"),
    url("iconfont.ttf?t=1661842038822") format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  height: 100%;
  width: 100%;
}
body {
  height: 100%;
  width: 100%;
  background: #2b39ad;
  /* font-size: 16px; */
}
html,
body {
  border: 0;
  padding: 0;
  margin: 0;
}
a {
  display: none;
}
.mint-indicator-wrapper {
  z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue